import pdpCustomPersonalization from './rbmc.pdp-custom-personalization';
import pdpPlayerPersonalization from './rbmc.pdp-player-personalization';
import pdpConfig from './rbmc.pdp-configurator-field';
import productDetails from './rbmc.pdp';
import pdpPatches from './rbmc.pdp-sponsor-patches';

const pdpTooltips = {
    loadTooltips() {
        setTimeout(function () {
            if (pdpPlayerPersonalization.selectPlayerOption.length) {
                pdpPlayerPersonalization.selectPlayerOption.parent().tooltip({
                    html:      true,
                    title:     pdpTooltips.tooltipTemplate(
                            pdpPlayerPersonalization.selectPlayerOption.data('tooltip-title'),
                            pdpPlayerPersonalization.selectPlayerOption.data('tooltip-confirm'),
                            pdpPlayerPersonalization.selectPlayerOption.data('tooltip-cancel'),
                            'pdp__tooltip-select-player'
                    ),
                    placement: productDetails.mobileActiveFlag ? 'top' : 'left',
                    trigger:   'manual'
                }).tooltip('update');
            }
            if (pdpCustomPersonalization.savePersonalization.length) {
                pdpCustomPersonalization.savePersonalization.tooltip({
                    html:      true,
                    title:     pdpTooltips.tooltipTemplate(
                            pdpCustomPersonalization.savePersonalization.data('tooltip-title'),
                            pdpCustomPersonalization.savePersonalization.data('tooltip-confirm'),
                            pdpCustomPersonalization.savePersonalization.data('tooltip-cancel'),
                            'pdp__tooltip-save-personalization'
                    ),
                    placement: productDetails.mobileActiveFlag ? 'top' : 'left',
                    trigger:   'manual'
                }).tooltip('update');
            }

            if (pdpConfig.personalizationPanel.length) {
                pdpConfig.personalizationPanel.find('.pdp__back').tooltip({
                    html:      true,
                    title:     pdpTooltips.tooltipTemplate(
                            pdpConfig.personalizationPanel.find('.pdp__back').data('tooltip-title'),
                            pdpConfig.personalizationPanel.find('.pdp__back').data('tooltip-confirm'),
                            pdpConfig.personalizationPanel.find('.pdp__back').data('tooltip-cancel'),
                            'pdp__tooltip-custom-personalization'
                    ),
                    placement: productDetails.mobileActiveFlag ? 'top' : 'left',
                    trigger:   'manual'
                }).tooltip('update');
            }
            if (pdpPatches.patchesPanel.length) {
                pdpPatches.patchesPanel.find('.pdp__icon-back').tooltip({
                    html:      true,
                    title:     pdpTooltips.tooltipTemplate(
                            pdpPatches.patchesPanel.find('.pdp__icon-back').data('tooltip-title'),
                            pdpPatches.patchesPanel.find('.pdp__icon-back').data('tooltip-confirm'),
                            pdpPatches.patchesPanel.find('.pdp__icon-back').data('tooltip-cancel'),
                            'pdp__tooltip-patches-leave'
                    ),
                    placement: productDetails.mobileActiveFlag ? 'top' : 'left',
                    trigger:   'manual'
                }).tooltip('update');
            }

            if (pdpCustomPersonalization.persName.length) {
                pdpCustomPersonalization.persName.tooltip({
                    html:      true,
                    title:     pdpTooltips.tooltipTemplateWithoutButton(
                            pdpCustomPersonalization.persName.data('tooltip-title')),
                    placement: productDetails.mobileActiveFlag ? 'top' : 'left',
                    trigger:   'manual'
                }).tooltip('update');
            }

            if (pdpCustomPersonalization.persNumber.length) {
                pdpCustomPersonalization.persNumber.tooltip({
                    html:      true,
                    title:     pdpTooltips.tooltipTemplateWithoutButton(
                            pdpCustomPersonalization.persNumber.data('tooltip-title')),
                    placement: productDetails.mobileActiveFlag ? 'top' : 'left',
                    trigger:   'manual'
                }).tooltip('update');
            }
        }, 500);
    },

    reloadTooltips() {
        pdpPlayerPersonalization.selectPlayerOption.parent().tooltip('dispose');
        pdpCustomPersonalization.savePersonalization.tooltip('dispose');
        pdpConfig.personalizationPanel.tooltip('dispose');
        pdpTooltips.loadTooltips();
    },

    tooltipTemplate(title, confirm, cancel, tooltipID) {
        return `<p>${title}</p>
                <div id="${tooltipID}" class="tooltip-buttons">
                    <div type="button" class="btn btn-secondary pdp__tooltip-cancel">${cancel}</div>
                    <div type="button" class="btn btn-primary pdp__tooltip-confirm">${confirm}</div>
                </div>`;
    },

    tooltipTemplateWithoutButton(title) {
        return `<p class="tooltip--paragraph-alone">${title}</p>`;
    },

    init() {
        pdpTooltips.loadTooltips();
    }
};

export default pdpTooltips;